import React, { useState, useEffect } from 'react';
import Loader from '../../../../components/Loader/Loader';
import axios from 'store/axios/axios-tr';
import { formatUTCtoPST, handleError } from '../../../../shared/utility';
import Notification from '../../../../components/Notification/Notification';
import ReactTable from "react-table";
import { IconButton } from '@material-ui/core';
import { statusDescriptions } from '../../../TR/Entries/TREntriesLogic';
import Button from '../../../../components/CustomButtons/Button';
import { getUser } from '../../../../shared/authValidation';

const name = 'Tenant Rep(s)';

const TenantRepSubTab = (props) => {
    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(false);
    const [notification, setNotification] = useState('');
    const { permsAll, perms } = props;

    const load = async () => {
        setLoading(true);
        try {
            const response = await axios.get('/entries?property_id='+props.property_id);
            console.log('loading', response.data);
            if (!response.data) throw "Could not load " + name;
            setEntries(response.data);
            setLoading(false);
        } catch(e) {
            handleError(e);
            setNotification('Could not load ' + name + ', please try again.');
            setLoading(false);
        }
    }

    const loadEntry = async () => {
        setLoading(true);
        try {
            const response = await axios.get('/entry?property_id='+props.property_id);
            console.log('loading', response.data);
            if (!response.data) throw "Could not load " + name;
            setEntries(response.data);
            setLoading(false);
        } catch(e) {
            handleError(e);
            setNotification('Could not load ' + name + ', please try again.');
            setLoading(false);
        }
    }

    useEffect(() => {
        load();
    }, []);

    const defaultSorted = props.defaultSorted
        ? props.defaultSorted
        : [
              {
                  id: "date",
                  desc: true,
              },
          ];

    const columns = [
        {
            Header: "ID #",
            accessor: "id" 
        },
        {
            Header: "Date Created",
            accessor: "created_date"
        },
        {
            Header: "Date Modified",
            accessor: "modified_date"
        },
        {
            Header: "Status",
            accessor: "status"
        },
        {
            Header: "Submitter",
            accessor: "name"
        },
        {
            Header: "Actions",
            accessor: "actions"
        }
    ]

    console.log('TenantRepSubTab', props, permsAll);

    const usr = getUser();

    return (
        <div>
            {permsAll.indexOf('TR fill_form') !== -1 &&
                                <Button color="primary"
                                    onClick={() => {
                                        window.location.href = '/tr?p=new&property_id='+props.property_id;
                                    }}
                                >Create New {name}</Button>}

            {loading && <Loader center={true} /> }

            {entries.length === 0 && <p>No Entry.</p>}

            <div className="react-table-hover-gray">
                <ReactTable
                    defaultSorted={defaultSorted}
                    data={entries.map(entry => {
                        let href = '';
                        // DRAFT 
                        if (entry.status === 1) {
                            if (entry.user_id === usr.id) {
                                // OWN
                                href = '/tr?p=open&tr_id='+entry.id;
                            }
                        } else if (entry.status === 9) {
                            // APPROVED
                            href = '/tr?p=open&tr_id='+entry.id;
                        }
                        return {
                            id: entry.id,
                            created_date: formatUTCtoPST(entry.created_date),
                            modified_date: formatUTCtoPST(entry.modified_date),
                            status: statusDescriptions[entry.status] ? statusDescriptions[entry.status] : '',
                            name: entry.name,
                            actions: <div>
                                {href && <IconButton
                                    onClick={() => {
                                        window.location.href = href
                                    }}
                                >
                                    <i className="fa fa-eye"></i>
                                </IconButton>}
                                {!href && <IconButton
                                    onClick={() => {
                                        
                                    }}
                                >
                                    <i className="fa fa-eye"></i>
                                </IconButton>}
                            </div>
                        }
                    })}
                    className="-striped"
                    showPaginationTop
                    showPaginationBottom
                    columns={columns}
                    resizable
                    defaultPageSize={10}
                    pageSizeOptions={[10, 20, 30]}
                    minRows={10}
                    filterable
                />
            </div>

            {notification && <Notification 
                open={true}
                close={() => {
                    setNotification('');
                }}
                message={notification}
            />}
        </div>
    );
};

export default TenantRepSubTab;
